// model
export * from "./core-ui";
import "../modern.scss";


// WEBPACK FOOTER //
// ./src/entries/core.ts